import { render, staticRenderFns } from "./site-support.vue?vue&type=template&id=b208123a&"
import script from "./site-support.vue?vue&type=script&lang=js&"
export * from "./site-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports